import { axiosClient } from "@/shared/api/axios-client";
import type {
  Area,
  CentroDeCosto,
  ClaveSat,
  PaginaClavesSat,
  CuentaContable,
  IndicadorImpuesto,
  TipoDocumentoAdicional,
} from "@/lib/types";

/**
 * Capa pura sobre los endpoints de catálogos de la API. Cada función es
 * idempotente y devuelve una Promise · sin hooks, sin React.
 */
export const catalogosApi = {
  listarAreas: () =>
    axiosClient.get<Area[]>("/api/catalogos/areas").then((r) => r.data),

  /**
   * Centros de costo. Con `numeroSociedad` la lista se acota a los CeCos VÁLIDOS
   * para esa organización (relación CeCo↔organización) · lo usa el picker del
   * wizard de prorrateo para ofrecer solo los centros de costo de la solicitud.
   * Sin él, devuelve el catálogo global (comportamiento histórico).
   */
  listarCentrosDeCosto: (numeroSociedad?: string) =>
    axiosClient
      .get<CentroDeCosto[]>("/api/catalogos/centros-de-costo", {
        params: numeroSociedad ? { numeroSociedad } : undefined,
      })
      .then((r) => r.data),

  /** Cuentas contables · con `numeroSociedad` solo las asignadas a esa organización (D-8). */
  listarCuentasContables: (numeroSociedad?: string) =>
    axiosClient
      .get<CuentaContable[]>("/api/catalogos/cuentas-contables", {
        params: numeroSociedad ? { numeroSociedad } : undefined,
      })
      .then((r) => r.data),

  /** Búsqueda EN EL SERVIDOR de las claves SAT utilizables hoy (el catálogo tiene ~52 mil · ya no se descarga completo). */
  buscarClavesSat: (params: { busqueda?: string; page?: number; pageSize?: number }) =>
    axiosClient
      .get<PaginaClavesSat>("/api/catalogos/claves-sat", { params })
      .then((r) => r.data),

  /** Descripción y vigencia de un conjunto de claves (las de las líneas del prorrateo). */
  consultarClavesSat: (claves: string[]) =>
    axiosClient
      .post<ClaveSat[]>("/api/catalogos/claves-sat/consultar", { claves })
      .then((r) => r.data),

  listarTiposDocumento: () =>
    axiosClient
      .get<TipoDocumentoAdicional[]>("/api/catalogos/tipos-documento")
      .then((r) => r.data),

  listarIndicadoresImpuesto: () =>
    axiosClient
      .get<IndicadorImpuesto[]>("/api/catalogos/indicadores-impuesto")
      .then((r) => r.data),
};
